
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class BioLuminescenceEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = this.pseudoRandom(x) * spacing;
                const offY = this.pseudoRandom(y) * spacing;
                const pulse = (Math.sin(time * config.parallaxSpeed + (x + y) * 0.1) + 1) * 0.5;
                const size = (20 + this.pseudoRandom(x * y) * 30) * scale * pulse;
                
                if (pulse > 0.1) {
                    const draw = () => {
                        const grad = ctx.createRadialGradient(x + offX, y + offY, 0, x + offX, y + offY, size);
                        grad.addColorStop(0, pc.color);
                        grad.addColorStop(1, 'transparent');
                        ctx.fillStyle = grad;
                        ctx.beginPath();
                        ctx.arc(x + offX, y + offY, size, 0, Math.PI * 2);
                        ctx.fill();
                    };
                    draw();
                    this.applyGlow(pc, draw);
                }
            }
        }
    }
}
